export const convertMilesToMeters = (radiusInMiles: number): number =>
	radiusInMiles * 1609.34
